import { render } from "./로그인.vue?vue&type=template&id=0cb2f0ce&lang=true"
import script from "./로그인.vue?vue&type=script&lang=js"
export * from "./로그인.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__